export default __webpack_public_path__ + "static/media/pde1.056245c5.png";